module.exports = __webpack_public_path__ + "99f063e2ee2a02db68dc9f7f132bd014.svg";